module.exports = __webpack_public_path__ + "img/index_others_newfixitem1.df425a76.png";